const configMap = {
  kr: {
    serviceStartDate: '2023-01-01',

    feature: {
      creditKind: true,
      pricingUnit: true,
      report: true,
      showExchangeRate: false,
      showProjectId: true,
    },

    topNavigation: {
      showAccountId: true,
    },

    billing: {
      commitmentAnalysis: {
        enabled: true,
      },
      costTable: {
        enabled: true,
      },
    },

    bq: {
      accounts: ['015094-17653F-EADCDD', '0137ED-B6B7D7-8B142C'],
    },

    ga: {
      hasGoogleAnalytics: true,
      trackingId: 'G-V48X096BBG',
    },

    // 빌원 인보이스를 보여줄 첫 청구월 (BO-3681). 그 이전 달은 hb2 가 이미 발행했다.
    // CSP 마다 이관 시점이 다르므로 default.js 공용값이 아니라 여기서 정한다.
    // 백엔드 하한(`billone.gcp.hb2-invoice.min-visible-month`)과 **같은 월**이어야 한다 —
    // 백엔드가 더 늦으면 여기서 보여주려는 달이 에러 없이 빈 채로 내려온다.
    invoice: {
      billone: {
        firstMonth: '2026-08',
      },
    },
  },
}

configMap.jp = {
  ...configMap.kr,
  serviceStartDate: '2019-01-01',

  megazoneAccount: {
    url: 'https://start.megazonejapan.jp/',
  },

  currencies: {
    default: 'JPY',
    krw: {
      enabled: false,
    },
    jpy: {
      enabled: true,
    },
  },

  languages: {
    default: 'en',
    korean: {
      enabled: false,
    },
  },

  personal: {
    ipAccessControl: {
      enabled: true,
    },
  },

  timezone: 'America/Los_Angeles',

  ga: {
    hasGoogleAnalytics: false,
  },
}

const config = window.serviceLoc ? configMap[window.serviceLoc] : configMap.kr
export default config
